import { render, staticRenderFns } from "./SPDossiers.vue?vue&type=template&id=5df85d76&"
import script from "./SPDossiers.vue?vue&type=script&lang=js&"
export * from "./SPDossiers.vue?vue&type=script&lang=js&"
import style0 from "./SPDossiers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports